import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import {
  resetImport,
  selectfaildData,
  selectprocessedData,
} from "../../features/importSlice";
import {
  useAddImportCategoryMutation,
  useCategoryListQuery,
  useMasterCategoryQuery,
} from "../../services/categoryApi";
import { useGroupsQuery } from "../../services/groupApi";
import SelectGroupImport from "../Common/CustomSelect/SelectGroupImport";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import CsvImporterCategories from "./csvImportCategories";
import SelectCategoryImportSubCategory from "../Common/CustomSelect/selectCategoryImportSubCategory";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

const ImportSubCategories = () => {
  const navigate = useNavigate();
  const user = signInUser();
  const { aamarId } = user;
  // console.log("aamarId", aamarId);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.importReducer);
  const csvData = data?.csvData;
  const processedData = data?.processedData;
  const faildData = data?.faildData;

  const [isProcess, setIsProcess] = useState(false); // Success Data
  const [pp, setPp] = useState(0); // Process Percent

  const [isImportedDone, setIsImportedDone] = useState(false);
  const [AddImportCategory] = useAddImportCategoryMutation();

  const { data: subCategories } = useCategoryListQuery({ aamarId });
  const { data: categories } = useMasterCategoryQuery({ aamarId });
  const { data: groups } = useGroupsQuery({ aamarId });
  // console.log("groups", groups);
  // console.log("subCategories", subCategories);

  // Function to handle input change
  const handleChange = (e, name) => {
    const match = processedData.find((p) => p.name === name);
    const rest = processedData.filter((p) => p.name !== name);
    const updated = {
      ...match,
      name: e,
      isNameUnique: checkCategoryName(e) || false,
    };
    dispatch(selectprocessedData([...rest, updated]));
  };

  // Function to handle input change
  const handleCategoryChange = (e, mc) => {
    const match = processedData.find((p) => p.mc === mc);
    const rest = processedData.filter((p) => p.mc !== mc);
    const updated = {
      ...match,
      name: e,
      isNameUnique: checkCategoryName(e) || false,
    };
    dispatch(selectprocessedData([...rest, updated]));
  };

  const handleImport = async () => {
    // console.log("Import", csvData.length, "Products");
    setIsImportedDone(true);

    let newProcessData = processedData;
    let newFailedData = [];
    for (const category of processedData) {
      console.log("categories", category);
      //  TODO:: category name
      const isDuplicate = await checkNameExists(category.name);

      if (isDuplicate) {
        newFailedData = [
          ...newFailedData,
          {
            name: category?.name || "",
            description: category?.description || "",
            category: category?.category || "",
            groups: category?.group || "",
            status: category?.status || "active",
          },
        ];
        continue;
      } else {
        if (category?.name !== null || category?.isNameUnique !== true) {
          // Resolve mc ID
          let mcValue = category.mc;
          const catSearch = category.category || category.mc;
          if (categories?.length && (!mcValue || !categories.some((c) => c._id === mcValue))) {
            const cleanCat = String(catSearch || "").trim().toLowerCase();
            const found = categories.find(
              (c) =>
                c._id === mcValue ||
                c.name?.trim().toLowerCase() === cleanCat ||
                String(c.mcId) === cleanCat
            );
            if (found) {
              mcValue = found._id;
            }
          }

          // Resolve group ID
          let groupValue = category.group;
          const grpSearch = category.groupName || category.group;
          if (groups?.length && (!groupValue || !groups.some((g) => g._id === groupValue))) {
            const cleanGrp = String(grpSearch || "").trim().toLowerCase();
            const found = groups.find(
              (g) =>
                g._id === groupValue ||
                g.name?.trim().toLowerCase() === cleanGrp
            );
            if (found) {
              groupValue = found._id;
            }
          }

          const payload = {
            ...category,
            mc: mcValue || null,
            group: groupValue || null,
          };

          //TODO:: Create each category
          const result = await AddImportCategory(payload);

          console.log("result", result);

          if (result?.status !== 500) {
            const matched = newProcessData.find(
              (p) => p.name === category?.name
            );
            const rest = newProcessData.filter(
              (p) => p.name !== category?.name
            );

            newProcessData = [...rest, { ...matched, isImport: true }];
          } else {
            newFailedData = [
              ...newFailedData,
              {
                name: category?.name || "",
                description: category?.description || "",
                category: category?.category || "",
                groups: category?.group || "",
                status: category?.status || "active",
              },
            ];
          }
        } else {
          newFailedData = [
            ...newFailedData,
            {
              name: category?.name || "",
              description: category?.description || "",
              category: category?.category || "",
              groups: category?.group || "",
              status: category?.status || "active",
            },
          ];
        }
      }
    }
    dispatch(selectfaildData(newFailedData));
    dispatch(selectprocessedData(newProcessData));
  };

  const getGroupIdbyName = (name) => {
    if (groups && name) {
      const cleanName = String(name).trim().toLowerCase();
      const result = groups?.find(
        (group) =>
          group?.name?.trim().toLowerCase() === cleanName ||
          group?._id === name
      );
      // console.log("group result", result);
      return result?._id || result?.name || name;
    } else {
      return name || null;
    }
  };
  const getCategoryIdbyName = (name) => {
    if (categories && name) {
      const cleanName = String(name).trim().toLowerCase();
      const result = categories?.find(
        (category) =>
          category?.name?.trim().toLowerCase() === cleanName ||
          category?._id === name ||
          String(category?.mcId) === cleanName
      );
      // console.log("categories result", result);
      return result?._id || null;
    } else {
      return null;
    }
  };
  // check Name
  const checkNameExists = async (name) => {
    try {
      const response = await fetch(
        ` ${BASE_URL}category/checkName/${aamarId}/${name}`
      );
      const data = await response.json();
      return data.exists; // Assuming API returns { exists: true } or { exists: false }
    } catch (error) {
      console.error("Error checking Article name:", error);
      return true; // Assume it exists if API fails, to prevent duplicates
    }
  };

  // TODO:: Generate code
  const generateCode = async () => {
    try {
      let code;
      let isUnique = false;

      while (!isUnique) {
        code = uuidv4().replace(/\D/g, "").slice(0, 6);

        // Ensure the first digit is not 0
        if (code.startsWith("0")) {
          continue; // Skip and generate a new one
        }

        isUnique = !(await checkCodeExists(code));
      }

      return code;
    } catch (error) {
      console.error("Error generating Article Code:", error);
      return null;
    }
  };



  const processCsvData = async (csvData) => {
    dispatch(selectprocessedData([]));
    dispatch(selectfaildData([]));
    let oldData = [];

    // console.log("CSV", csvData);
    let i = 1;
    for (const category of csvData) {
      const rawCat =
        category?.category ??
        category?.Category ??
        category?.categoryName ??
        category?.["Category Name"] ??
        category?.["category_name"] ??
        category?.master_category ??
        category?.masterCategory ??
        category?.mc ??
        "";

      const rawGrp =
        category?.group ??
        category?.Group ??
        category?.groupName ??
        category?.["Group Name"] ??
        category?.["group_name"] ??
        "";

      const cleanCat = String(rawCat).trim().toLowerCase();
      const matchedCategory = categories?.find(
        (c) =>
          c?.name?.trim().toLowerCase() === cleanCat ||
          c?._id === rawCat ||
          String(c?.mcId) === cleanCat
      );

      const cleanGrp = String(rawGrp).trim().toLowerCase();
      const matchedGroup = groups?.find(
        (g) =>
          g?.name?.trim().toLowerCase() === cleanGrp ||
          g?._id === rawGrp
      );

      const newcategory = {
        name: category?.name,
        code: (await generateCode()) || null,
        mcId: matchedCategory?.mcId || (await generateCode()) || null,
        mc: matchedCategory?._id || (getCategoryIdbyName(rawCat)) || null,
        category: matchedCategory?.name || (rawCat ? String(rawCat).trim() : null),
        group: matchedGroup?._id || (getGroupIdbyName(rawGrp)) || null,
        groupName: matchedGroup?.name || (rawGrp ? String(rawGrp).trim() : null),
        description: category?.description,
        aamarId: aamarId,
        status: category?.status || "active",

        //
        order: i++,
        readyToIport: true,
        isImport: false,
        isEditable: checkCategoryName(category?.name) || false,
        isNameUnique: checkCategoryName(category?.name) || false,
      };
      // console.log("newcategory", newcategory);

      oldData = [...oldData, newcategory];

      pp >= 0 && setIsProcess(false);

      pp === 100 && setIsProcess(false);
    }

    dispatch(selectprocessedData(oldData));
  };

  useEffect(() => {
    // console.log("CSV", csvData);
    // console.log("csvData Changes");
    if (csvData?.length > 0) {
      if (csvData?.length !== processedData?.length) {
        csvData?.length > 0 && processCsvData(csvData);
      }
    }
  }, [csvData]);

  useEffect(() => {
    // console.log("CSV", csvData);
    // console.log("csvData Changes");
    if (csvData?.length > 0) {
      if (csvData?.length !== processedData?.length) {
        csvData?.length > 0 && processCsvData(csvData);
      }
    }
  }, []);

  useEffect(() => {
    setIsProcess(true);
    setPp(0);
    // let progress = 0;
    const processPercent = (100 / csvData?.length) * processedData?.length;

    // console.log("Process Percent");
    setPp(processPercent || 0);
    // setIsProcess(true);
    // csvData.length > 0 && processCsvData(csvData);
  }, [processedData]);

  // console.log("processedData", processedData);

  const checkCategoryName = (name) => {
    return (
      !subCategories?.some(
        (category) => category?.name?.toLowerCase() === name?.toLowerCase()
      ) || false
    );
  };

  // check code
  const checkCodeExists = async (code) => {
    return (
      subCategories?.some(
        (category) => category?.code?.toLowerCase() === code?.toLowerCase()
      ) || false
    );
  };


  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2">
            <SideBar />
          </div>
          <div className="col-md-10">
            <Header title="Import Sub Category" />
            <div className="row">
              <div className="col-md-12">
                {csvData?.length <= 0 ? (
                  <div
                    className="d-flex align-items-center justify-content-center vh-100"
                    style={{ marginTop: "-80px" }}
                  >
                    <div className="col-6">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <p className="m-0 p-0 fw-bold">Import Sub Category</p>
                          <p className="m-0 p-0">
                            <small>
                              Please check the format before uploading
                              <a
                                href="/importSample/importSubCategorySample.csv"
                                download
                                className="d-inline-flex align-items-center text-decoration-none text-opacity-75 text-primary gap-1"
                                style={{ transition: "color 0.3s ease-in-out" }}
                              >
                                <Icons.Download size="15" />
                                Download
                              </a>{" "}
                              the sample file
                              {/* File to check the format before uploading. */}
                            </small>
                          </p>
                        </div>
                      </div>
                      <div>
                        <CsvImporterCategories />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <p className="d-flex justify-content-between p-2">
                        Total Product: {csvData?.length}{" "}
                        <span className="input-category-text">
                          <span
                            className="input-category-text gap-2"
                            id="basic-addon1"
                          >
                            {isImportedDone && faildData?.length > 0 && (
                              // TODO:: MAKE THIS BUTTON EXPOrt FAILD

                              <CSVLink
                                data={faildData}
                                filename="failed_products.csv"
                                className="btn btn-dark"
                              >
                                <Icons.Download size="18" /> Export Failed Data
                              </CSVLink>
                            )}
                            {!isImportedDone && (
                              <button
                                onClick={() => handleImport()}
                                className="btn btn-block btn-dark"
                                style={{ zIndex: 0 }}
                              >
                                <Icons.Upload size="18" /> Import Sub Category
                              </button>
                            )}
                            {!isImportedDone && (
                              <button
                                onClick={() => {
                                  processCsvData(csvData);
                                  setIsImportedDone(false);
                                }}
                                className="btn btn-block btn-outline-dark"
                                style={{ zIndex: 0 }}
                              >
                                <Icons.Refresh size="18" /> Reload
                              </button>
                            )}

                            <button
                              onClick={() => {
                                dispatch(resetImport());
                                setIsImportedDone(false);
                              }}
                              className="btn btn-block btn-outline-dark"
                              style={{ zIndex: 0 }}
                            >
                              {!isImportedDone ? "Cancle" : "Import Again"}{" "}
                              <Icons.X size="18" />
                            </button>
                            {isImportedDone && (
                              <button
                                onClick={() => {
                                  dispatch(resetImport());
                                  setIsImportedDone(false);
                                  navigate("/subcategory");
                                }}
                                className="btn btn-block btn-outline-success"
                                style={{ zIndex: 0 }}
                              >
                                <Icons.CheckCircle size="18" /> Done
                              </button>
                            )}
                          </span>
                        </span>
                      </p>
                    </div>
                    {!isProcess ? (
                      <div className="col-12 col-md-6 offset-md-3">
                        <div
                          className="d-flex flex-column align-items-left justify-content-center w-100"
                          style={{ height: "60vh" }}
                        >
                          <h3>Processing Data {pp}%</h3>
                          <div className="w-100">
                            <ProgressBar
                              animated
                              striped
                              variant="success"
                              now={pp}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="col-12 table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Sub Category Name</th>
                              <th>Description</th>
                              <th>Code</th>
                              <th>Category</th>
                              <th>Group</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {processedData.length > 0 ? (
                              processedData
                                ?.slice()
                                ?.sort((a, b) => a.order - b.order)
                                ?.map((item, index) => (
                                  <tr key={index}>
                                    <th>{index + 1}</th>
                                    <td>
                                      {item?.isEditable ? (
                                        item?.name
                                      ) : (
                                        <input
                                          className="form-control"
                                          value={item?.name}
                                          onChange={(e) =>
                                            handleChange(
                                              e.target.value,
                                              item?.name
                                            )
                                          } // If needed for editing
                                          style={{
                                            border: `1px solid ${
                                              item?.isNameUnique ? "" : "tomato"
                                            }`,
                                            outline: "none",
                                            width: "200px", // Adjust the width as needed
                                            padding: "5px", // To ensure text fits comfortably
                                          }}
                                        />
                                      )}
                                    </td>
                                    {/* {console.log("item", item)} */}

                                    <td>{item?.description}</td>
                                    <td>{item?.code}</td>
                                      {/* Category */}
                                    <td>
                                      {categories?.length > 0 ? (
                                        <SelectCategoryImportSubCategory
                                          categories={categories}
                                          code={item?.code}
                                          // article_code={item?.article_code}
                                          categoryName={
                                            item?.category ||
                                            csvData?.[index]?.category ||
                                            csvData?.[index]?.Category ||
                                            csvData?.[index]?.categoryName ||
                                            csvData?.[index]?.["Category Name"] ||
                                            csvData?.[index]?.["category_name"] ||
                                            csvData?.[index]?.master_category ||
                                            item?.mc
                                          }
                                          // mcId={item?.mc}
                                        />
                                      ) : (
                                        item?.category ||
                                        csvData?.[index]?.category ||
                                        csvData?.[index]?.Category ||
                                        item?.mc
                                      )}
                                    </td>

                                    <td
                                      style={{
                                        width: "200px",
                                      }}
                                    >
                                      {/* {console.log("group name", item.group)} */}
                                      {groups?.length > 0 ? (
                                        <SelectGroupImport
                                          processedData={processedData}
                                          groups={groups}
                                          code={item?.code}
                                          gp={item?.group}
                                        />
                                      ) : (
                                        item?.name
                                      )}
                                    </td>

                                    <td
                                      className={
                                        item?.isEditable
                                          ? item?.isNameUnique
                                            ? "text-success"
                                            : item?.isImport
                                            ? item?.isNameUnique
                                              ? "text-danger"
                                              : "text-success"
                                            : "text-success"
                                          : item?.isNameUnique
                                          ? "text-success"
                                          : "text-danger"
                                      }
                                    >
                                      {item?.isEditable
                                        ? item?.isNameUnique
                                          ? "Ready"
                                          : item?.isImport
                                          ? item?.isNameUnique
                                            ? "Failed"
                                            : "Ready"
                                          : "Ready"
                                        : item?.isNameUnique
                                        ? item?.isImport
                                          ? "Done"
                                          : "Ready"
                                        : "Failed"}
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan="15" className="text-center">
                                  No Data Available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <Toaster position="bottom-right" />
        </div>
      </div>
    </div>
  );
};

export default ImportSubCategories;
